import { TenantInterface, UserInterface, UserVarKey, UserVarsMap } from "@swivl-mono/types";
import { useEffect, useMemo, useState } from "react";

import { DetailsPanel } from "../../../../Components/Conversations/DetailsPanel/DetailsPanel";
import { DataCardLocation } from "../../../../Components/DataCards/DataCard.Location";
import { DataCardTenant } from "../../../../Components/DataCards/DataCard.Tenant";
import Pill, { PillSize, PillStyle, PillType } from "../../../../Components/Pill/Pill";
import LocationsModel from "../../../../Models/Locations/Locations.Model";
import TenantsModel from "../../../../Models/Tenants/Tenants.Model";
import { NameRow } from "../Components/NameRow/NameRow";
import UserDetailsEditCustomerDetailsView from "./UserDetails.EditCustomerDetails.View";

interface UserDetailsCustomerDetailsViewProps {
  user: UserInterface;
  userVars: UserVarsMap | undefined;
}

export function UserDetailsCustomerDetailsView({ user, userVars }: UserDetailsCustomerDetailsViewProps) {

  const [isEditing, setIsEditing] = useState(false);
  const tabs = ["Edit Customer Details"];

  const { tenants } = TenantsModel.useState((s) => s);
  const locationId = user.locationId ?
    user.locationId
    : userVars && userVars[UserVarKey.Location]
      ? parseInt(userVars[UserVarKey.Location])
      : undefined;

  useEffect(() => {
    LocationsModel.getGroupsAndLocations(false);
    TenantsModel.getTenantsByUserId(user.id);
  }, [locationId, user.id]);

  const filteredTenants = useMemo(() => {
    if (!locationId) {
      return [];
    }
    return tenants?.filter((t) => t.locationId === locationId) || [];
  }, [tenants, locationId]);

  const handleSetIsEditing = () => {
    setIsEditing(!isEditing);
  };

  return (
    <>
      <div className="flex flex-col space-y-6">
        {user && userVars && <NameRow user={user} vars={userVars} handleSetIsEditing={handleSetIsEditing} />}
        {userVars &&
          filteredTenants.length > 0 &&
          filteredTenants?.map((tenant: TenantInterface) => {
            return <DataCardTenant key={tenant.id} tenant={tenant} userVars={userVars} />;
          })}
        {userVars && (!filteredTenants.length || userVars[UserVarKey.Location]) && (
          <DataCardLocation
            title="Prospect Profile"
            locationId={user && user.locationId ? user.locationId : undefined}
            pills={[<Pill type={PillType.ORANGE} size={PillSize.SMALL} style={PillStyle.DARK} text="Selected"></Pill>]}
            variant="secondary"
          />
        )}
      </div>
      <DetailsPanel
        isOpen={isEditing}
        onClose={() => setIsEditing(false)}
        renderTab={(tab, _, isPanelOpen) => {
          switch (tab) {
            case "Edit Customer Details":
              return <UserDetailsEditCustomerDetailsView isPanelOpen={isPanelOpen} user={user} userVars={userVars} />;
            default:
              return null;
          }
        }}
        tabs={tabs}
      />
    </>
  );
}
